<template>
  <div class="father">
    <div class="link">
      <div class="colspan1" id="bottomMenuContent">
        <div class="friend-box clearfix">
          <div class="title">友情链接</div>
          <div class="f-content">
            <p v-for="item in friendlyLinkList" :key="item.id">
              <a
                :href="item.url"
                v-if="item.target_type==1"
                target="_blank"
                :title="item.name"
              >{{item.name}}</a>
              <a
                :href="item.url"
                v-if="item.target_type==2"
                target="_self"
                :title="item.name"
              >{{item.name}}</a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="info">
      <div class="colspan2">
        <div class="top">
          <div class="left">
            <div>
              <span class="footerTitle">{{webconfig.title}}</span>
            </div>
          </div>
          <div class="center">
            <span v-if="webconfig.title">{{webconfig.title}}</span>
            <span v-if="webconfig.gov_record">
              <a
                style="text-decoration:none; color:#dcdcdc; "
                target="_blank"
                :href="webconfig.gov_record_url"
              >{{webconfig.gov_record}}</a>
            </span>
            <span v-if="webconfig.postcode">邮政编码：{{webconfig.postcode}}</span>
            <span v-if="webconfig.icp_no">
              <a
                style="text-decoration:none; color:#dcdcdc; "
                target="_blank"
                href="http://www.beian.miit.gov.cn/"
              >{{webconfig.icp_no}}</a>
            </span>
            <span v-if="webconfig.id_code">网站标识码：{{webconfig.id_code}}</span>

            <span v-if="webconfig.tel">联系电话：{{webconfig.tel}}</span>
            <span v-if="webconfig.email">联系邮箱：{{webconfig.email}}</span>
            <span v-if="webconfig.work_time">工作时间：{{webconfig.work_time}}</span>
            <span v-if="webconfig.address">联系地址：{{webconfig.address}}</span>
          </div>
          <div class="code_box">
            <div class="qrcode_box">
              <div id="qrcode" ref="qrcode"></div>
              <p>捐赠二维码</p>
            </div>
            <div class="tencent">
              <div class="image">
                <img
                  v-if="webconfig.wechat_qrcode_text"
                  :src="webconfig.wechat_qrcode_text.url"
                  alt
                />
              </div>
              <p>公众号二维码</p>
            </div>
          </div>
        </div>
        <div class="footer">
          <p class="left">(建议您使用IE9及以上版本的浏览器访问本站)</p>
          <p v-if="$store.state.webInfo.style!='yueyang'" @click="gotoPyy" class="right">技术支持：长沙普益云软件科技有限公司</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      webconfig: {},
      friendlyLinkList: [],
      isShow: false,
      bottomMenuColor: "#424242",
      textMenuColor: "#fff",
      menuLeftWidth: 0
    };
  },
  mounted() {
    this.getWebconfigInfo().then(res => {
      this.webconfig = res;
      this.$store.state.webInfo = res;
    }).catch(err => {
            console.log(err);
          });

    this.qrcode();
  },
  methods: {
    ...mapActions(["getWebconfigInfo"]),
    qrcode() {
      setTimeout(() => {
        let url = "";
        if (this.$store.state.webInfo.style == "huarong") {
          url = this.$store.state.webInfo.donation_url 
        } else {
          url =
            this.$store.state.webInfo.donation_url +
            this.$store.state.webInfo.donation_project_id;
        }

        new QRCode(this.$refs.qrcode, {
          text: url,
          width: 84,
          height: 84,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.L
        });
      }, 100);
    },
    // 友情链接
    friendlyLink() {
      if (this.$store.state.webInfo.style !== "changde") {
        this.$db.get(this.$url.friendlyLink.list).then(res => {
          this.friendlyLinkList = res.data;
        }).catch(err => {
            console.log(err);
          });
      }
    },
    gotoPyy() {
      window.open("http://www.puyiyun.com", "_blank");
    }
  },
  created() {
    this.friendlyLink();
  }
};
</script>
<style lang="less" scoped>
.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
#qrcode {
  display: inline-block;
}
#qrcode /deep/ img {
  padding: 6px;
  background-color: #fff;
}
.father {
  margin-top: 20px;
  min-width: 1200px;
  .link {
    width: 100%;
    background-color: #424242;
    border-bottom: 1px solid #686868;
    .colspan1 {
      margin: 0 auto;
      width: 1200px;
      .friend-box {
        padding: 10px 0;
        .title {
          line-height: 31px;
          font-size: 16px;
          margin: auto 0;
          color: #dcdcdc;
          float: left;
        }
        .f-content {
          margin-left: 20px;
          width: 1100px;
          float: left;
          > p {
            display: block;
            margin: 0 5px;
            line-height: 30px;
            float: left;
            > a {
              font-size: 14px;
              // margin-right: 20px;
              text-decoration: none;
              color: #dcdcdc;
            }
          }
        }
      }
    }
  }
  .info {
    width: 100%;
    height: 280px;
    background-color: #3e3e3e;
    .colspan2 {
      margin: 0 auto;
      width: 1200px;
      position: relative;
      > .top {
        height: 230px;
        > .left {
          float: left;
          overflow: hidden;
        }
        .footerTitle {
          font-size: 22px;
          color: #a3a6a9;
          line-height: 230px;
        }
        > .center {
          width: 640px;
          float: left;
          margin-top: 50px;
          font-size: 14px;
          margin-left: 5%;

          > span {
            line-height: 28px;
            color: #dcdcdc;
            width: 50%;
            display: inline-block;
          }
          span:nth-child(odd) {
            width: 45%;
          }
        }
        .code_box {
          float: right;
          margin-top: 49px;
          > .tencent {
            float: left;
            margin-right: 20px;
            > p {
              color: #dcdcdc;
              text-align: center;
              margin: 21px 0;
            }
            .image {
              height: 96px;
              > img {
                width: 96px;
                height: 96px;
              }
            }
          }
          > .qrcode_box {
            float: left;
            margin-right: 20px;
            #qrcode {
              display: inline-block;
              box-sizing: border-box;
              height: 96px;
            }
            #qrcode /deep/ img {
              background-color: #fff; //设置白色背景色
              padding: 6px; // 利用padding的特性，挤出白边
            }
            > p {
              color: #dcdcdc;
              text-align: center;
            }
          }
        }
      }
      > .footer {
        height: 50px;
        line-height: 50px;
        position: relative;
        color: #dcdcdc;
        border-top: 1px solid #686868;
        p {
          margin: 0;
          font-size: 14px;
        }
        > .left {
          position: absolute;
          left: 0;
          bottom: 0;
        }
        > .right {
          cursor: pointer;
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
    }
  }
}
</style>
<style lang="less">
.el-menu--horizontal.bottomChildMenu {
  width: 1200px !important;
  line-height: 50px;
  left: 50% !important;
  margin-left: -600px;
  border-bottom: 0px solid #424242;
  ul.el-menu.el-menu--popup.el-menu--popup-bottom-start {
    width: 100% !important;
    background-color: #fff !important;
    color: #424242;
    padding-top: 0px;
    padding-bottom: 0px;
    li {
      min-width: 180px;
      height: 46px;
      line-height: 46px;
      text-align: center;
      background-color: #fff !important;
      float: left;
      a {
        color: #424242;
        text-decoration: none;
        display: inline-block;
        width: 100%;
      }
      a:hover,
      a:focus {
        color: #000;
      }
    }
    li:hover {
      background: rgba(0, 0, 0, 0.3) !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/footer.vue